import { render, staticRenderFns } from "./MbUiVideo.vue?vue&type=template&id=cb616f9c&scoped=true&"
import script from "./MbUiVideo.vue?vue&type=script&lang=js&"
export * from "./MbUiVideo.vue?vue&type=script&lang=js&"
import style0 from "./MbUiVideo.vue?vue&type=style&index=0&id=cb616f9c&lang=scss&scoped=true&"
import style1 from "./MbUiVideo.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb616f9c",
  null
  
)

export default component.exports